import { useRequest } from 'ahooks';
import { getThinktankContent} from '../../../axios/api'

function useGetThinktankContent(){
  const {  data:getThinktankContentData, loading:getThinktankContentLoading,runAsync:getThinktankContentAction } = useRequest(
    async (params) => {
      try {
        const resp = await getThinktankContent({...params})
        return resp?.data ?? undefined
      } catch (error) {
        // message.error('获取知识点失败！');
        return undefined;
      }
    },
    {
      debounceWait: 240,
      manual: true,
    },
  );

    return {
      getThinktankContentData,
      getThinktankContentLoading,
      getThinktankContentAction
    
    }
}

export default useGetThinktankContent